import ApiCaller from "./apiCaller";

export const getExistedStatus = (type: "site" | "store") => {
  return ApiCaller.get(`graph?content_type=${type}`);
};

export const getListRole = () => ApiCaller.get("brand/roles");

export const toggleStatusRole = (body: any) =>
  ApiCaller.put("status_role", body);

export const toggleStatusDefaultRoleAssignment = (body: any) =>
  ApiCaller.put("status/default_role_assigment", body);

export const getStatusRole = (id: number) =>
  ApiCaller.get(`status_role?status_id=${id}`);

export const updateCoordinatorStatus = (
  coordinate: { x: number; y: number },
  id: number
) => {
  return ApiCaller.put(`graph/node/${id}`, coordinate);
};

export const createEdge = (data: { source: number; target: number }) => {
  return ApiCaller.post("graph/edge", data);
};

export const deleteEdge = (data: { source: number; target: number }) => {
  return ApiCaller.delete("graph/edge", data);
};
